import { call, put, takeEvery } from "redux-saga/effects";
import { objectToQueryString } from "helpers/queryString";

import {
	ActionsSearchProducts,
	failureSearchProducts,
	loadGetSearchProducts,
	loadSearchProductsSuccess,
} from "./actions";

function* loadDataSearchProducts(params = {}) {

	try {

		yield put(loadGetSearchProducts());

		const queryParams = objectToQueryString({
			next_id: params.payload.next_id,
			page: !params.payload.next_id ? params.payload.page : 1,
			limit: params.payload.limit,
			type: params.payload.type,
			sort: params.payload.sort,
			keyword: params.payload.keyword,
		});
		const endpoint = `${process.env.NEXT_PUBLIC_ROOT_DOMAIN}/api-new/searchProducts?${queryParams}`;

		const headers = params.payload.is_server
			? { ...params.payload.headers }
			: {
				...params.payload.headers,
				// endpoint: api_endpoint,
			};
		const method = "GET";
		const options = { headers, method };

		const response = yield call(fetch, endpoint, options);
		if (response.status >= 200 && response.status < 300) {

			const data = yield response.json();

			yield put(loadSearchProductsSuccess(data));

		} else {

			yield put(failureSearchProducts);

		}

	} catch (err) {

		yield put(failureSearchProducts(err));

	}

}

export default function* rootSaga() {

	yield takeEvery(
		ActionsSearchProducts.GET_SEARCH_PRODUCTS,
		loadDataSearchProducts,
	);

}
